// extracted by mini-css-extract-plugin
export var surveySessionCategoryTitle = "survey-session-category-title-module--survey-session-category-title--c2opZ";
export var title = "survey-session-category-title-module--title--qiYuE";